import { render } from "./ModalFeesDetail.vue?vue&type=template&id=4ec0db34&ts=true"
import script from "./ModalFeesDetail.vue?vue&type=script&lang=ts"
export * from "./ModalFeesDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__